import { attributes, Collection, define } from "@type-r/models";
import { Loading } from "lqx-react";
import * as React from "react";
import { useIO, useLinked, useModel } from "@type-r/react";
import { globalStore } from "api";
import { TimeRangeTypes } from "../../api";
import { LandingItems } from "../../common/landing-items";
import { LandingPaymentInfo } from "../common";

const TIME_RANGE_DEFAULT = TimeRangeTypes.slice(1)[0].val;

@define
export class AutoReconciledPaymentsState extends attributes({
    payments: [LandingPaymentInfo],
    isReady: Boolean
}) {
    async fetch(options?) {

        const autoReconciledPayments = await LandingPaymentInfo.fetchAutoReconciledPayments(options ? options.$timeRange.value : TIME_RANGE_DEFAULT);

        this.payments.set(autoReconciledPayments);

        this.payments.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    }

    getCount() {
        return this.payments.reduce((sum: number, curr) => sum + (curr ? curr.count : 0), 0);
    }
}

export const AutoReconciledPayments = ({ state }: { state: AutoReconciledPaymentsState }) => {
    
    const $timeRange = useLinked(TIME_RANGE_DEFAULT);
    state.isReady = useIO(async () => {

        await state.fetch({ $timeRange });
    }, [$timeRange.value]);

    return (
        state.isReady ?
            <LandingItems
                title={`Review items (${state.getCount()})`}
                items={state.payments}
                linkUrl='/inmatch/matching/reconciled'
                type='auto-reconciled-payments'
                $timeRange={$timeRange}
            />
            :
            <Loading />
    );
}